import React from 'react';

const Fb = ({ width = 6, height = 14, fill = '#fff', ...rest }) => (
  <svg width={6} height={14} viewBox="0 0 6 14" {...rest}>
    <path
      d="M4 4.8V3.7v-.4c0-.1.1-.2.1-.3.1-.1.1-.1.3-.2.1 0 .3-.1.5-.1H6V.5H4.2c-1 0-1.8.2-2.2.7-.5.5-.7 1.2-.7 2.2v1.3H0v2.2h1.3v6.5H4V7h1.8L6 4.8H4z"
      fill={fill}
      fillRule="evenodd"
    />
  </svg>
);

export default Fb;
